import { Routes } from '@angular/router';
import { AuthGuardService } from './shared/services/auth-guard.service';

export const routes: Routes = [
  {
    path: 'swimlane',
    loadComponent: () =>
      import(
        './shared/components/swimlane-diagram/swimlane-diagram.component'
      ).then((m) => m.SwimLaneDiagramComponent),
    canActivate: [AuthGuardService],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./modules/home/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./modules/home/home.component').then((m) => m.HomeComponent),
    loadChildren: () =>
      import('./modules/home/home.routes').then((m) => m.HOME_ROUTES),
    data: { preload: true },
    canActivate: [AuthGuardService],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
